import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "bb_age_verified";

export default function AgeGate({ children }) {
  const [verified, setVerified] = useState(true);
  const [rejected, setRejected] = useState(false);

  useEffect(() => {
    setVerified(localStorage.getItem(STORAGE_KEY) === "true");
  }, []);

  const enter = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVerified(true);
  };

  return (
    <>
      {children}
      <AnimatePresence>
        {!verified && (
          <motion.div
            key="age-gate"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black flex items-center justify-center px-6"
            data-testid="age-gate"
          >
            {/* Radial pink glow */}
            <div
              aria-hidden
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "radial-gradient(ellipse at 50% 90%, rgba(255,61,139,0.35) 0%, transparent 60%)",
              }}
            />
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.6, ease: "easeOut" }}
              className="relative z-10 max-w-xl w-full text-center"
            >
              <div className="font-display text-5xl sm:text-6xl mb-3 leading-none">
                <span className="text-[#FF3D8B]">Booty</span>
                <span className="text-[#A855F7]"> Breeze</span>
              </div>
              <div className="font-display text-7xl sm:text-8xl text-neon-pink mb-2">18+</div>
              <p className="text-white/70 text-sm sm:text-base mb-8 max-w-md mx-auto leading-relaxed">
                This site contains adult-themed products. By entering, you confirm you're at
                least 18 years old and legally allowed to view mature content in your region.
              </p>

              {rejected ? (
                <div className="text-white/60 text-sm" data-testid="age-gate-rejected">
                  Sorry — you must be 18 or older to enter Booty Breeze.
                </div>
              ) : (
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <button
                    onClick={enter}
                    data-testid="age-gate-confirm-btn"
                    className="pulse-pink px-8 py-4 rounded-full bg-[#FF3D8B] text-black font-bold uppercase tracking-wider text-sm hover:bg-[#ff5ba0] transition-colors"
                  >
                    I'm 18 or older — Enter
                  </button>
                  <button
                    onClick={() => setRejected(true)}
                    data-testid="age-gate-reject-btn"
                    className="px-8 py-4 rounded-full border border-white/20 text-white/80 uppercase tracking-wider text-sm hover:border-white/40 hover:text-white transition-colors"
                  >
                    Take me back
                  </button>
                </div>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
